<div>
  <div (click)="onToggleVisible()">
    @if (isFloatLabel) {
      <p-floatLabel>
        <input
          type="text"
          pInputText
          [readOnly]="true"
          [placeholder]="placeholder"
          [class]="'w-full truncate ' + styleClass"
          [disabled]="isDisabled"
          [variant]="isDisabled ? 'filled' : 'outlined'"
          (click)="isDisabled ? $event.stopPropagation() : onTouched($event)"
          [ngClass]="{ 'border border-red-500': isError && !isVisible }"
          [value]="valueStr" />
        @if (showClearIcon && (value || (multiple && selectedOptions.length > 0))) {
          <i
            class="icon-wl-close absolute right-8 top-2 text-5 cursor-pointer text-neutral-600"
            (click)="clearSelection($event)"></i>
        }
        <i
          class="icon-wl-arrow-drop-down absolute right-3 top-2 text-7"
          (click)="isDisabled ? $event.stopPropagation() : onTouched($event)"></i>
        <label for="username"
          ><span>{{ label }} </span>
          @if (required) {
            <span class="text-red-600">*</span>
          }
        </label>
      </p-floatLabel>
    } @else {
      <input
        type="text"
        pInputText
        [readOnly]="true"
        [placeholder]="placeholder"
        [class]="'w-full ' + styleClass"
        [disabled]="isDisabled"
        [variant]="isDisabled ? 'filled' : 'outlined'"
        (click)="isDisabled ? $event.stopPropagation() : onTouched($event)"
        [ngClass]="{ 'border border-red-500': isError && !isVisible }"
        [value]="valueStr" />
      @if (showClearIcon && (value || (multiple && selectedOptions.length > 0))) {
        <i
          class="icon-wl-close absolute right-8 top-2 text-5 cursor-pointer text-neutral-600"
          (click)="clearSelection($event)"></i>
      }
      @if (isDropdownIcon) {
        <i class="icon-wl-arrow-drop-down absolute right-[39px] top-[350px] text-6"></i>
      }
    }
  </div>

  <p-overlay appendTo="body" #overlay [(visible)]="isVisible" contentStyleClass="rounded-md shadow bg-white w-full">
    <app-search-input
      inputClass="border-none !shadow-none"
      [debounceTime]="300"
      (onSearch)="onSearch($event)"></app-search-input>
    <div
      class="w-full max-h-[200px] overflow-y-auto"
      infiniteScroll
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50"
      [scrollWindow]="false"
      (scrolled)="onScroll()">
      @if (options.length) {
        @if (multiple) {
          @for (option of options; track option.id) {
            <div class="flex px-3 hover:bg-neutral-200 py-2 gap-2">
              <p-checkbox
                [(ngModel)]="selectedOptions"
                (onChange)="onSelectOptions()"
                [value]="option"
                [disabled]="option?.status?.code === StatusUser.HIDDEN || option?.status?.code === StatusUser.INACTIVE">
              </p-checkbox>
              <app-custom-avatar [imgId]="option?.avatar ?? ''" [name]="getOptionLabel(option)"></app-custom-avatar>
              <div
                class="cursor-pointer w-full truncate"
                [ngClass]="{
                  'text-neutral-400':
                    option?.status?.code === StatusUser.HIDDEN || option?.status?.code === StatusUser.INACTIVE
                }">
                {{ getOptionLabel(option) }}
              </div>
            </div>
          }
        } @else {
          <div
            class="h-10 leading-10 px-4 hover:bg-neutral-200 cursor-pointer w-full truncate flex gap-2 items-center"
            *ngFor="let option of options"
            (click)="onSelectOption(option)"
            [ngClass]="{
              'bg-neutral-alpha-300A':
                option?.status?.code === StatusUser.HIDDEN || option?.status?.code === StatusUser.INACTIVE
            }">
            <div class="min-w-5">
              @if (isOptionSelected(option)) {
                <i class="icon-wl-check text-6 text-primary-600"></i>
              }
            </div>

            <app-custom-avatar [imgId]="option?.avatar ?? ''" [name]="getOptionLabel(option)"></app-custom-avatar>
            <div class="w-full truncate">
              {{ getOptionLabel(option) }}
            </div>
          </div>
        }
      } @else {
        <div class="flex items-center justify-center flex-col gap-2 py-4">
          @if (loading) {
            <i class="pi pi-spin pi-spinner text-6"></i>
          } @else {
            <div class="h-9 w-9 flex items-center justify-center bg-neutral-alpha-200A rounded-full">
              <i class="icon-wl-user text-6"></i>
            </div>

            <div>No users to display</div>
          }
        </div>
      }
    </div>
  </p-overlay>
</div>
